import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { emptyQuizzes } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectAssessmentReadyEpisodeIds,
  selectPlayerSessionsResult,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EmptyView } from '../EmptyView';

export const AssessmentReady = () => {
  const compliance = useSelector(selectUserCompliance);
  const { isSuccess: isPlayerSessionsSuccess } = useSelector(
    selectPlayerSessionsResult,
  );
  const assessmentReadyEpisodeIds = useSelector(
    selectAssessmentReadyEpisodeIds,
  );

  const {
    data: episodes = [],
    isLoading,
    isSuccess,
  } = useFetchEpisodesQuery(
    {
      episodeIds: assessmentReadyEpisodeIds,
      compliance,
    },
    {
      skip: !assessmentReadyEpisodeIds.length,
    },
  );

  const isEmpty =
    (isPlayerSessionsSuccess && !assessmentReadyEpisodeIds.length) ||
    (isSuccess && !episodes.length);

  return (
    <Box>
      {isEmpty ? (
        <EmptyView
          title="Unlock your credit"
          subtitle="Finish an episode and the related assessment will appear here."
          img={emptyQuizzes}
        />
      ) : (
        <EpisodeGrid
          isLoading={isLoading}
          episodes={episodes}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.MY_LUMIQ,
            section: EVENT_CONSTANTS.SECTION.ASSESSMENTS,
          }}
        />
      )}
    </Box>
  );
};
